module.exports = __webpack_public_path__ + "img/web_heart_animation.313656d4.png";